import React from "react";
import { View, TextInput, Keyboard } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import i18n from "../../locales/i18n";

interface ProductSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  setIsDropdownVisible: (visible: boolean) => void;
  customStyle?: string;
  SetOpenCam: (open: boolean) => void;
  locale: string;
}

const ProductSearch: React.FC<ProductSearchProps> = ({
  searchQuery,
  setSearchQuery,
  setIsDropdownVisible,
  customStyle,
  SetOpenCam,
  locale,
}) => {
  return (
    <View
      className={`bg-white rounded-full border border-gray-300 ${customStyle ? customStyle : "w-2/3"
        }`}
      style={{
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 1,
        },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 3,
      }}
    >
      <View
        style={{
          flexDirection: locale === "ar" ? "row-reverse" : "row",
          alignItems: "center",
          paddingHorizontal: 16,
        }}
        className="w-full"
      >
        <TextInput
          style={{
            flex: 1,
            fontSize: 16,
            height: 45,
            paddingHorizontal: 10,
            backgroundColor: "transparent",
            color: "#1F2937",
          }}
          placeholder={i18n.t("searchForProduct")}
          placeholderTextColor="#9CA3AF"
          value={searchQuery}
          autoCapitalize="none"
          onFocus={() => SetOpenCam(false)}
          onChangeText={(text) => {
            setSearchQuery(text);
            setIsDropdownVisible(text.length > 0);
          }}
          className={`${locale === "ar" ? "text-right" : "text-left"}`}
          onSubmitEditing={Keyboard.dismiss}
        />

        <MaterialIcons name="search" size={20} color="#9CA3AF" />
      </View>
    </View>
  );
};

export default ProductSearch;
